









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ActivityIcon, CheckIcon, XIcon } from 'vue-feather-icons';
import { CUSTOMER_STATUS_LABELS, CustomerStatus } from 'admiral-core';

@Component({
  name: 'CustomerStatusFilter',
  components: { ActivityIcon, CheckIcon, XIcon },
})
export default class CustomerStatusFilter extends Vue {
  @Prop({ type: Array, default: () => [] })
  statusFilter!: CustomerStatus[];

  hovered = false;

  /** Alle Status-Optionen für das Dropdown. */
  get statusOptions(): { value: CustomerStatus; label: string }[] {
    return Object.values(CustomerStatus).map((value) => ({
      value,
      label: CUSTOMER_STATUS_LABELS[value],
    }));
  }

  get displayLabel(): string {
    if (this.statusFilter.length === 0) {
      return 'Alle Status';
    }
    if (this.statusFilter.length === 1) {
      return CUSTOMER_STATUS_LABELS[this.statusFilter[0]];
    }
    return `${CUSTOMER_STATUS_LABELS[this.statusFilter[0]]} + ${this.statusFilter.length - 1}`;
  }

  isSelected(value: CustomerStatus): boolean {
    return this.statusFilter.includes(value);
  }

  /** Schaltet einen Status im Mehrfachfilter. */
  toggleStatus(value: CustomerStatus) {
    const newStatuses = this.isSelected(value)
      ? this.statusFilter.filter((s) => s !== value)
      : [...this.statusFilter, value];
    this.$emit('update:statusFilter', newStatuses);
  }

  clearFilter() {
    this.$emit('update:statusFilter', []);
  }
}
